import { FileUploadFile, Option } from '@bbl-digital/snorre-v2'
import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'shared/store/store'

export enum UploadFilesSteps {
  UPLOAD_FILES = 1,
  ADD_ADDITIONAL_INFORMATION = 2,
  PUBLISH_DOCUMENTS = 3,
}

export type UploadedFile = {
  uploadedFile: FileUploadFile
  displayName: string
  id: number
  uploadedIsSuccess?: boolean
  uploading?: boolean
}

export type AdditionalInformation = {
  documentType: string
  date: string
  tags: Option[]
  sharedWithBbl: boolean
  description: string
}

export type UploadFilesState = {
  files: UploadedFile[]
  additionalInformation: AdditionalInformation
  step: UploadFilesSteps
}

const initialState: UploadFilesState = {
  files: [],
  additionalInformation: {
    documentType: '',
    date: new Date().toISOString(),
    tags: [],
    sharedWithBbl: false,
    description: '',
  },
  step: UploadFilesSteps.UPLOAD_FILES,
}

export const uploadFilesSlice = createSlice({
  name: 'uploadFilesModalSlice',
  initialState,
  reducers: {
    reset: () => initialState,
    setFiles: (state, action) => {
      state.files = action.payload
    },
    setStep: (state, action) => {
      state.step = action.payload
    },
    setAdditionalInformation: (state, action) => {
      state.additionalInformation = action.payload
    },
    setFileUploadStatus: (state, action) => {
      const { id, uploadedIsSuccess } = action.payload as {
        id: number
        uploadedIsSuccess: boolean
      }
      const fileToUpdate = state.files.find((f) => f.id === id)
      if (fileToUpdate) {
        fileToUpdate.uploadedIsSuccess = uploadedIsSuccess
      }
    },
    setFileUploading: (state, action) => {
      const { id, uploading } = action.payload as {
        id: number
        uploading: boolean
      }
      const fileToUpdate = state.files.find((f) => f.id === id)
      if (fileToUpdate) {
        fileToUpdate.uploading = uploading
      }
    },
  },
})

export const getUploadFilesState = (state: RootState) =>
  state.uploadFilesModalSlice

export const {
  setFiles,
  setStep,
  setAdditionalInformation,
  setFileUploadStatus,
  setFileUploading,
  reset,
} = uploadFilesSlice.actions
export default uploadFilesSlice
